import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import PaymentDetailsDialog from "../../list/components/PaymentDetailsDialog";

const MOCK_PAYMENTS: Array<any> = [
  { id: 1, reference: "INV-2026-0007", amount: 100, status: "PAID", paymentMethod: "CARD", paidAt: "2026-07-15", invoiceUrl: "#" } as any,
  { id: 2, reference: "INV-2026-0006", amount: 100, status: "PAID", paymentMethod: "CARD", paidAt: "2026-06-15", invoiceUrl: "#" } as any,
  { id: 3, reference: "INV-2026-0005", amount: 100, status: "FAILED", paymentMethod: "TRANSFER", paidAt: "2026-05-15", invoiceUrl: "#" } as any,
];

const PaymentDetails = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [selectedPayment, setSelectedPayment] = useState<any | null>(null);
  const [openDetailsDialog, setOpenDetailsDialog] = useState(false);

  useEffect(() => {
    if (id) {
      const payment = MOCK_PAYMENTS.find(p => p.id === parseInt(id));
      if (payment) {
        setSelectedPayment(payment);
        setOpenDetailsDialog(true);
      }
    }
  }, [id]);

  const handleCloseDetailsDialog = () => {
    setOpenDetailsDialog(false);
    setSelectedPayment(null);
    navigate("../payments");
  };

  return (
    <PaymentDetailsDialog
      open={openDetailsDialog}
      onClose={handleCloseDetailsDialog}
      payment={selectedPayment}
    />
  );
};

export default PaymentDetails;